import React from 'react';
import Icon from '../../../components/AppIcon';


const SubscriptionTierCard = ({ 
  tier, 
  isSelected, 
  onSelect, 
  isPopular = false 
}) => {
  const getTierIcon = (tierName) => {
    const icons = {
      'free': 'User',
      'starter': 'Rocket',
      'professional': 'Crown',
      'enterprise': 'Building'
    };
    return icons?.[tierName] || 'User';
  };

  const getTierColor = (tierName) => {
    const colors = {
      'free': 'text-muted-foreground',
      'starter': 'text-primary',
      'professional': 'text-secondary',
      'enterprise': 'text-accent'
    };
    return colors?.[tierName] || 'text-muted-foreground';
  };

  return (
    <div
      className={`relative bg-card border-2 rounded-lg p-6 transition-all duration-300 cursor-pointer hover:shadow-lg ${
        isSelected
          ? 'border-primary shadow-md'
          : 'border-border hover:border-primary/50'
      }`}
      onClick={onSelect}
    >
      {isPopular && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-accent text-accent-foreground text-xs font-semibold rounded-full">
          Most Popular
        </div>
      )}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className={`w-12 h-12 rounded-lg bg-muted flex items-center justify-center ${getTierColor(tier?.id)}`}>
            <Icon name={getTierIcon(tier?.id)} size={24} />
          </div>
          <div>
            <h3 className="text-lg font-heading font-semibold text-foreground">
              {tier?.name}
            </h3>
            <p className="text-sm text-muted-foreground">{tier?.description}</p>
          </div>
        </div>
        {isSelected && (
          <div className="w-6 h-6 rounded-full bg-primary flex items-center justify-center flex-shrink-0">
            <Icon name="Check" size={16} color="var(--color-primary-foreground)" />
          </div>
        )}
      </div>
      <div className="mb-6">
        <div className="flex items-baseline space-x-2">
          <span className="text-3xl font-heading font-bold text-foreground">
            ${tier?.price}
          </span>
          <span className="text-sm text-muted-foreground">/month</span>
        </div>
        <p className="text-xs text-muted-foreground mt-1">{tier?.quota}</p>
      </div>
      <ul className="space-y-3 mb-6">
        {tier?.features?.map((feature, index) => (
          <li key={index} className="flex items-start space-x-2">
            <Icon
              name="Check"
              size={16}
              className="flex-shrink-0 mt-0.5 text-success"
            />
            <span className="text-sm text-foreground">{feature}</span>
          </li>
        ))}
      </ul>
      {tier?.id !== 'free' && (
        <div className="pt-4 border-t border-border">
          <div className="flex items-center space-x-2 text-xs text-muted-foreground">
            <Icon name="Shield" size={14} />
            <span>Includes Skool community access</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubscriptionTierCard;